
import { Routes, Route  } from 'react-router-dom';

//Pages
import LoginPage from "./Pages/Login/Login"
import OrderListing from './Pages/OrderListing/OrderListing'
import UsersCrud from './Pages/UsersCrud/UsersCrud'
import EquipmentsListing from './Pages/Equipments/EquipmentListing';

const Routing =() => {
    return (
        <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/orderListing" element={ <OrderListing />} />
            <Route path="/usersCrud" element={ <UsersCrud />} />
            <Route path="/equipmentListing" element={ <EquipmentsListing />} />
        </Routes>
    );
}

export default Routing;